import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { useAssessmentProgressOptional } from '~/client/components/assessment/assessment-progress-context';
import ProgressWithText from '~/client/components/progress-with-text';
import { useLeftNavContext } from '~c/components/base/left-nav';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props {
  className?: string;
  policyName?: string;
  completionPercent?: number | null;
  assessmentId?: string;
}

const CurrentStatusImpl: React.FC<Props> = ({
  className,
  policyName,
  completionPercent,
  assessmentId,
}) => {
  const { state } = useLeftNavContext();
  const progressContext = useAssessmentProgressOptional();

  // Get live assessment completion from context, fallback to prop value
  const liveCompletion = assessmentId
    ? progressContext?.getAssessmentCompletion(assessmentId)
    : undefined;
  const displayCompletion = liveCompletion ?? completionPercent;

  return (
    <>
      <div className={className}>
        <Text sz="body16" color="white" noWrap sx={{ mb: spc.xxs }}>
          {policyName ?? 'Policy name'}
        </Text>
        <ProgressWithText
          value={displayCompletion}
          hideProgressBar={!state.open}
          inNav
        />
      </div>
      <div style={{ paddingBottom: '16px' }}>
        <div className="divider" />
      </div>
    </>
  );
};

/**
 * Rendering the header for the assessment left nav
 */
export const CurrentStatus = muiStyled(CurrentStatusImpl)(
  ({ theme }) => css`
    padding: 0px 16px;
    color: ${theme.palette.text.secondary};
  `
);

export default CurrentStatus;
